// Web Push registrácia — PWA notifikácie na nový doklad na schválenie.
//
// iOS (16.4+): funguje LEN v appke pridanej na plochu a subscribe musí ísť
// z kliknutia usera — preto sa nič nedeje automaticky, všetko štartuje
// tlačidlo/prepínač v UI. Existencia subscription = súhlas (backend nemá
// samostatnú preferenciu).
import api from '../api';

const b64ToUint8 = (b64: string) => {
  const pad = '='.repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, '+').replace(/_/g, '/'));
  return Uint8Array.from(raw.split('').map(c => c.charCodeAt(0)));
};

export const pushSupported = () =>
  'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;

async function registration(): Promise<ServiceWorkerRegistration> {
  const reg = await navigator.serviceWorker.register('/sw.js');
  await navigator.serviceWorker.ready;
  return reg;
}

/** Aktuálny stav tohto zariadenia: 'on' | 'off' | 'unsupported' | 'denied' */
export async function pushState(): Promise<'on' | 'off' | 'unsupported' | 'denied'> {
  if (!pushSupported()) return 'unsupported';
  if (Notification.permission === 'denied') return 'denied';
  try {
    const reg = await navigator.serviceWorker.getRegistration('/sw.js');
    const sub = await reg?.pushManager.getSubscription();
    return sub ? 'on' : 'off';
  } catch { return 'off'; }
}

/** Zapnutie — MUSÍ bežať z user gestúry (klik). */
export async function enablePush(): Promise<void> {
  const perm = await Notification.requestPermission();
  if (perm !== 'granted') throw new Error('Notifikácie neboli povolené v prehliadači');
  const { data } = await api.get('/push/vapid-key');
  const reg = await registration();
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: b64ToUint8(data.key),
  });
  await api.post('/push/subscribe', { subscription: sub.toJSON() });
}

export async function disablePush(): Promise<void> {
  const reg = await navigator.serviceWorker.getRegistration('/sw.js');
  const sub = await reg?.pushManager.getSubscription();
  if (sub) {
    await api.post('/push/unsubscribe', { endpoint: sub.endpoint }).catch(() => {});
    await sub.unsubscribe();
  }
}
